import { MrbBaseRouteStore } from "mrb/core";
import { ProducerContentTreeService, ProducerReportService, ProducerUserAccountService } from "common/services";

class ContentTreeRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.contentTreeService = rootStore.createApplicationService(ProducerContentTreeService);
        this.reportService = rootStore.createApplicationService(ProducerReportService);
        this.producerUserAccountService = rootStore.createApplicationService(ProducerUserAccountService);
    }

    async getProducers(abortSignal = null) {
        const response = await this.producerUserAccountService.getProducers(abortSignal);
        return response.data;
    }

    async getContentTree(producerId, abortSignal = null) {
        const response = await this.contentTreeService.getContentTree(producerId, abortSignal);
        return response.data;
    }

    async getRevenueMap(producerId, abortSignal = null) {
        const response = await this.reportService.findRevenueMap({ producerId }, abortSignal);
        return response.data;
    }

    // Cover thumbnails are built by the view store via the shared CoverImageFactory using the
    // coverImageId the content-tree API returns on each node.
}

export default ContentTreeRouteStore;
